import * as React from 'react';
import { observer } from 'mobx-react-lite';
import { Row, Col } from 'antd';
import { CustomDivider } from '../../../custom_shared/components';
import { InputBaseModel } from '../../models';
import { ContractComparisonChangeLabel, InputRenderer } from '..';
import { InputChangeType } from '../../types';
import './ContractComparisonRow.less';
import '../ContractComparisonColumns.less';

interface Props {
    changeType?: InputChangeType;
    newInput?: InputBaseModel;
    previousInput?: InputBaseModel;
    component?: React.FunctionComponent;
    isLast: boolean;
}

const ContractComparisonRow: React.FC<Props> = ({ changeType, newInput, previousInput, component, isLast }) => {
    const renderInput = (input?: InputBaseModel, isUnsavedInput: boolean = false) => {
        if (!input) {
            return (
                <div className="no-input-container">
                    <span className="no-input-label">—</span>
                </div>
            );
        }

        return (
            <div className={`comparison-input-container${isUnsavedInput ? ' unsaved' : ''}`}>
                <InputRenderer input={input} component={component} />
            </div>
        );
    };

    return (
        <>
            <Row className="contract-comparison-row contract-comparison-columns">
                <Col>{renderInput(previousInput)}</Col>
                <Col>{renderInput(newInput, changeType === 'unsaved')}</Col>
                <Col className="contract-comparison-status">
                    {changeType && <ContractComparisonChangeLabel changeType={changeType} />}
                </Col>
            </Row>

            {!isLast && <CustomDivider type="horizontal" />}
        </>
    );
};

export default observer(ContractComparisonRow);
